import Vue from 'vue'
const $this = this
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        userItem:{},
    },
    mutations: {
        //初始化访客列表
        initialize (state,provider) {
            state.userItem = provider;
        },
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js